import { Separator } from "@/components/ui/separator";

import { ArticlesIcon, BlogIcon, NewsIcon, OperatorsIcon } from "./icons";
import Menu, { MenuItem, type MenuProps } from "./menu";

interface BlogMenuProps extends Omit<MenuProps, "children" | "label"> {}

export default function BlogMenu(props: BlogMenuProps) {
  return (
    <Menu label="Blog" {...props}>
      <MenuItem href="/blog/articles" icon={<ArticlesIcon />} isExternal>
        Articles
      </MenuItem>
      <MenuItem href="/blog/news" icon={<NewsIcon />} isExternal>
        News
      </MenuItem>
      <MenuItem href="/blog/for-operators" icon={<OperatorsIcon />} isExternal>
        For operators
      </MenuItem>
      <Separator className="bg-white/10" orientation="horizontal" />
      <MenuItem href="/blog" icon={<BlogIcon />} isExternal>
        Blog home
      </MenuItem>
    </Menu>
  );
}
